// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import {img_url} from '../img_url';
import {Button} from '../../lib/button';
import styles from './new_mm.module.less';
import {use_haff_download} from '../../ui/haffnetwork/use_haff_download';

const Nbsp = '\u00A0';

/* eslint-disable */
export enum Product {
    Vpn = 'vpn',
    Browser = 'browser'
}
const product_names = {
    [Product.Vpn]: 'Hola VPN',
    [Product.Browser]: 'Hola Browser',
};
/* eslint-enable */

interface i_product_props {
    product: Product;
}

const Highlight = x=>{
    return <span className={styles.highlight}>{x}</span>;
};
const Bullet_point = ({num, highlight, text})=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.bullet_point_wrapper}>
      <div className={styles.bullet}>{num}</div>
      <p className={theme.p1}>{Highlight(highlight)} {text}</p>
    </div>;
};
const Bullet_points = ()=>{
    const data = [
      {hl: 'Safer.', text: 'All your data is encrypted - keeping you safe!'},
      {hl: 'Unlimited.', text:
          'Enjoy unlimited data - nothing will stop you!'},
      {hl: 'Faster.', text: 'Faster. The fastest VPN on the market - '
          +'HD streaming with no buffering!'},
    ];
    return <div className={styles.bullet_points_container}>
      {data.map((x, i)=>
        <Bullet_point key={i} num={i+1} highlight={x.hl} text={x.text}/>)}
    </div>;
};
const Encouragement = (props: i_product_props)=>{
    const {product} = {...props};
    const {theme} = useContext(Settings_context);
    const {handle_download} = use_haff_download({
        perr_pref: `land_new_mm_${props.product}`,
        force_vpn_dl: product===Product.Vpn
    });
    return <div className={cn(theme.container,
      styles.encouragement_container)}>
      <h1>Top 3 reasons
        to{Nbsp}try {product_names[product]} {Highlight('for free!')}</h1>
      <Bullet_points/>
      <Button width={317}
        caption={`Download ${product_names[product]}`}
        round on_click={handle_download} cls={styles.btn_multiline}/>
    </div>;
};
const Navbar = (props: i_product_props)=>{
    const {handle_download} = use_haff_download({
        perr_pref: `land_new_mm_${props.product}_navbar`,
        force_vpn_dl: props.product===Product.Vpn
    });
    return <div className={styles.navbar}>
      <img src={img_url('hola_logo.svg')} alt="logo"
        className={cn(styles.logo, 'lazyload')}/>
      <Button width={171} size={'sm'}
        caption={'Free download'}
        round on_click={handle_download} cls={styles.btn_navbar}/>
    </div>;
};
const Content = (props: i_product_props)=>{
    return <div className={styles.content}>
      <Encouragement {...props}/>
      <div className={styles.picture}/>
    </div>;
};
export const New_mm_page = (props: i_product_props)=>{
    return <div className={cn(styles.haff_newmm_page, styles[props.product])}>
      <Navbar {...props}/>
      <div className={styles.content_wrapper}>
        <Content {...props}/>
      </div>
    </div>;
};
